import React, { createContext, useContext, useState, useEffect } from "react";
import { api, currentMonth } from "../lib/api";

const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [users, setUsers] = useState(["Greg", "Kristi"]);
  const [activeUser, setActiveUser] = useState(() => localStorage.getItem("activeUser") || "Greg");
  const [month, setMonth] = useState(currentMonth());

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const cats = await api.getCategories();
        if (!cancelled && (!cats || cats.length === 0)) {
          await api.seed();
        }
        const settings = await api.getSettings();
        if (cancelled) return;
        const list = settings.users && settings.users.length ? settings.users : ["Greg", "Kristi"];
        setUsers(list);
        const stored = localStorage.getItem("activeUser");
        if (!stored || !list.includes(stored)) {
          setActiveUser(list[0]);
          localStorage.setItem("activeUser", list[0]);
        }
      } catch (e) {
        console.error("init error", e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const switchUser = (u) => {
    setActiveUser(u);
    localStorage.setItem("activeUser", u);
  };

  return (
    <AppContext.Provider value={{ users, setUsers, activeUser, setActiveUser, switchUser, month, setMonth, ready: true }}>
      {children}
    </AppContext.Provider>
  );
};
